exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".block-style.success{border:1px solid #38c172;border-left-width:8px}.block-style.error{border:1px solid #e3342f;border-left-width:8px}.block-style{border-radius:4px;box-shadow:0 .125rem .25rem rgba(0,0,0,.075)!important}.upload-file-form{margin-top:10px}", ""]);

// exports
